import CalculatorIcon from '@mui/icons-material/Calculate'
import { Box, Fab, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { FC, useState } from 'react'
import { connect } from 'react-redux'
import { CabinetSizesType, CornerCabinetSizesType, UserType } from '../../../api/appAPI'
import { ConfigsType } from '../../../config'
import { ConfigDescriptionType, actions as appActions, editCabinetSizes, editConfig } from '../../../redux/appReducer'
import { StateType } from '../../../redux/store'
import { EnqueueSnackbarType } from '../../common/Helpers'
import InchCalculator from '../../common/InchCalculator'
import CabinetSizes from './CabinetSizes'
import CornerCabinetSizes from './CornerCabinetSizes'
import EditConfig from './EditConfig'

// const RoleCellEditComponent: FC<{
//     myRole: RoleType
//     userRole: RoleType

//     submitChange(role: RoleType): void
// }> = ({ userRole, myRole, submitChange }) => {

//     const [role, setRole] = useState(userRole)

//     return (myRole === 'company' || myRole === 'admin')
//         ?

//         <Box display='flex' width={1} alignItems='center'>
//             <FormControl style={{ width: '100%' }} variant='outlined' size='small'>
//                 <Select
//                     value={role}
//                     onChange={(e) => { setRole(e.target.value as RoleType) }}
//                     displayEmpty
//                 >
//                     <MenuItem value='none'>None</MenuItem>
//                     <MenuItem value='designer'>Designer</MenuItem>
//                     {myRole === 'admin' && <MenuItem value='dealer'>Dealer</MenuItem>}
//                     {myRole === 'admin' && <MenuItem value='company'>Company</MenuItem>}
//                     {myRole === 'admin' && <MenuItem value='admin'>Admin</MenuItem>}
//                 </Select>
//             </FormControl>
//             <IconButton onClick={() => { submitChange(role) }}>
//                 <CheckIcon style={{ color: '#4caf50' }} />
//             </IconButton>
//         </Box>
//         : <></>
// }

// const RoleCellComponent: FC<{
//     role: RoleType

//     onEditClick(): void
// }> = ({ role, onEditClick }) => {

//     return <Box display='flex' width={1} alignItems='center' justifyContent='space-between'>
//         <Typography style={{ color: role === 'none' ? 'red' : '' }} >{role}</Typography>
//         <IconButton onClick={() => { onEditClick() }}>
//             <EditIcon />
//         </IconButton>
//     </Box>
// }

interface IProps {
    user: UserType | undefined
    isConfigsFetched: boolean
    configs: ConfigsType
    configsDescriptions: ConfigDescriptionType[]
    cabinetSizes: undefined | CabinetSizesType
    cornerCabinetSizes: undefined | CornerCabinetSizesType

    setActiveTab(value: number): void
    setAdminActiveTab(value: number): void
    editConfig(name: string, value: string, description: string, enqueueSnackbar: EnqueueSnackbarType): void
    editCabinetSizes(name: string, value: string, enqueueSnackbar: EnqueueSnackbarType): void
}

const ConfigsTab: FC<IProps> = props => {

    const [activeConfig, setActiveConfig] = useState<undefined | { name: string, value: string, description: string }>(undefined)
    const [isCalculatorOpen, setIsCalculatorOpen] = useState(false)

    if (!props.user) return <></>

    if (props.user.role !== 'admin') {
        props.setActiveTab(0)
        props.setAdminActiveTab(0)
    }

    return (
        <Box
            display='flex'
            style={{ height: window.innerHeight - 48 * 2, position: 'relative' }}
        >
            <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                pt={2}
                style={{ borderRight: 'solid 1px black', width: '50%' }}
            >
                <Typography variant='h6'>Configs List</Typography>

                <DataGrid
                    style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}
                    columns={[
                        { field: 'id', headerName: 'Name', minWidth: 200 },
                        { field: 'description', headerName: 'Description', width: 300 },
                        { field: 'value', headerName: 'Value', width: 300 },
                    ]}
                    // hideFooterPagination
                    rows={[{
                        id: 'cabinetSizes',
                        value: '',
                        description: 'Cabinet\'s possible sizes'
                    }, {
                        id: 'cornerCabinetSizes',
                        value: '',
                        description: 'Corner Cabinet\'s possible sizes'
                    }, ...Object.keys(props.configs).map(key => ({
                        id: key,
                        value: JSON.stringify(props.configs[key as keyof typeof props.configs]),
                        description: props.configsDescriptions.find(c => c.name === key)?.description || ''
                    }))]}
                    onRowClick={(param) => {
                        if (param.id.toString() === 'cabinetSizes')
                            setActiveConfig({
                                name: param.id.toString(),
                                value: '',
                                description: ''
                            })
                        else
                            setActiveConfig({
                                name: param.id.toString(),
                                value: param.row.value || '',
                                description: param.row.description || ''
                            })
                    }}

                />
            </Box>
            {activeConfig !== undefined &&
                (activeConfig.name === 'cabinetSizes'
                    ? (props.cabinetSizes ? <CabinetSizes cabinetSizes={props.cabinetSizes} editCabinetSizes={props.editCabinetSizes} /> : <>Error</>)
                    : activeConfig.name === 'cornerCabinetSizes'
                        ? (props.cornerCabinetSizes ? <CornerCabinetSizes cabinetSizes={props.cornerCabinetSizes} editCabinetSizes={props.editCabinetSizes} /> : <>Error</>)
                        : <EditConfig config={activeConfig} editConfig={props.editConfig} />
                )
            }

            {isCalculatorOpen
                ? <InchCalculator onClose={() => { setIsCalculatorOpen(false) }} />
                : <Fab size='small' color='primary' onClick={() => setIsCalculatorOpen(true)} sx={{
                    position: 'absolute',
                    top: 10, right: 10
                }} >
                    <CalculatorIcon />
                </Fab>
            }

        </Box>
    )
}

const mapStateToProps = (state: StateType) => ({
    user: state.appReducer.user,
    configs: state.appReducer.configs,
    configsDescriptions: state.appReducer.configsDescriptions,
    isConfigsFetched: state.appReducer.isConfigsFetched,
    cabinetSizes: state.appReducer.cabinetSizes,
    cornerCabinetSizes: state.appReducer.cornerCabinetSizes,
})

export default connect(mapStateToProps, {
    setActiveTab: appActions.setActiveTab,
    setAdminActiveTab: appActions.setAdminActiveTab,
    editConfig, editCabinetSizes
})(ConfigsTab)